import Vue from 'vue'
import i18next from 'i18next'
import i18backend from 'i18next-xhr-backend'
import LngDetector from 'i18next-browser-languagedetector'
import VueI18Next from '@panter/vue-i18next'
import locale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import frLocale from 'element-ui/lib/locale/lang/fr'
import esLocale from 'element-ui/lib/locale/lang/es'
import deLocale from 'element-ui/lib/locale/lang/de'
import { SERVER_URL } from '@/settings'

import store from '@/store'

Vue.use(VueI18Next)
locale.use(enLocale)

i18next.on('languageChanged', function (lng) {
  const currentLng = lng.substr(0, 2)
  Vue.config.lang = currentLng
  switch (currentLng) {
    case 'fr':
      locale.use(frLocale)
      break
    case 'es':
      locale.use(esLocale)
      break
    case 'de':
      locale.use(deLocale)
      break
    case 'en':
    default:
      locale.use(enLocale)
      break
  }

  store.dispatch('langChanged', currentLng)
  store.dispatch('dataStructure', i18next.getResourceBundle(currentLng))
})

i18next
  .use(i18backend)
  .use(LngDetector)
  .init({
    whitelist: ['fr', 'es', 'en', 'de'],
    detection: {
      order: ['querystring', 'navigator', 'cookie', 'localStorage', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
      caches: ['localStorage', 'cookie'],
      // excludeCacheFor: ['cimode'],
      // cookieMinutes: 60,
      // cookieDomain: '',
      htmlTag: document.documentElement
    },
    fallbackLng: {
      'fr': ['en'],
      'es': ['en'],
      'de': ['en'],
      'default': ['en']
    },
    load: 'languageOnly',
    debug: false,
    backend: {
      loadPath: SERVER_URL + '{{ns}}s/{{lng}}.json',
      crossDomain: true
    }
  }, (err, t) => {
    if (err) console.log('Something went wrong loading', err)
    store.dispatch('ready')
  })

const i18n = new VueI18Next(i18next)
export default i18n
